import { createAnatomy as g } from "../../anatomy/dist/index.mjs";
import { createScope as a } from "../../dom-query/dist/index.mjs";
import { createProps as o } from "../../types/dist/index.mjs";
var n = g("pagination").parts("root", "item", "ellipsis", "prevTrigger", "nextTrigger");
n.build();
a({
  getRootId: (i) => {
    var e;
    return ((e = i.ids) == null ? void 0 : e.root) ?? `pagination:${i.id}`;
  },
  getPrevTriggerId: (i) => {
    var e;
    return ((e = i.ids) == null ? void 0 : e.prevTrigger) ?? `pagination:${i.id}:prev`;
  },
  getNextTriggerId: (i) => {
    var e;
    return ((e = i.ids) == null ? void 0 : e.nextTrigger) ?? `pagination:${i.id}:next`;
  },
  getEllipsisId: (i, e) => {
    var t, r;
    return ((r = (t = i.ids) == null ? void 0 : t.ellipsis) == null ? void 0 : r.call(t, e)) ?? `pagination:${i.id}:ellipsis:${e}`;
  },
  getItemId: (i, e) => {
    var t, r;
    return ((r = (t = i.ids) == null ? void 0 : t.item) == null ? void 0 : r.call(t, e)) ?? `pagination:${i.id}:item:${e}`;
  }
});
o()([
  "count",
  "dir",
  "getRootNode",
  "id",
  "ids",
  "onPageChange",
  "onPageSizeChange",
  "page",
  "pageSize",
  "siblingCount",
  "translations",
  "type"
]);
o()(["value", "type"]);
o()(["index"]);
export {
  n as anatomy
};
